// extracted by mini-css-extract-plugin
module.exports = {"ShoppingCart":"ShoppingCart_ShoppingCart__3lH4G","cart":"ShoppingCart_cart__7znHr"};